var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguremartialarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.2964 28.0664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.0664,
    opacity: 0,
    width: 21.2964,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39236 5.12109C9.79861 5.12109 10.9353 3.97266 10.9353 2.54297C10.9353 1.13672 9.79861 0 8.39236 0C6.96268 0 5.81424 1.13672 5.81424 2.54297C5.81424 3.97266 6.96268 5.12109 8.39236 5.12109ZM13.7596 27.9023C14.4392 27.9023 14.9666 27.3633 14.9666 26.707L14.9666 20.0508C14.9666 19.7695 14.8142 19.3711 14.4392 19.125L10.1619 16.2773L10.1619 9.03516C10.1619 8.88281 10.2908 8.74219 10.4549 8.74219L19.7478 8.74219C20.4158 8.74219 20.9431 8.20312 20.9431 7.54688C20.9431 6.89062 20.4158 6.35156 19.7478 6.35156L6.52908 6.35156C5.40408 6.35156 4.79471 6.75 4.22049 7.46484L1.1033 11.2969C0.353301 12.2109 0.962676 13.5352 1.93533 13.5352L5.38064 13.5352L5.38064 15.1875C5.38064 16.2773 5.99002 17.2969 6.97439 17.8242L12.5642 20.8359L12.5642 26.707C12.5642 27.3633 13.1033 27.9023 13.7596 27.9023ZM4.16189 11.2148L5.45096 9.60938L5.45096 11.2148ZM0.282989 27.4922C0.74002 28.0078 1.49002 28.0312 1.99393 27.5977L6.69314 23.4844C6.92752 23.2734 7.02127 23.1797 7.1033 22.957L8.35721 19.8398L6.43533 18.8086C6.24783 18.7031 6.06033 18.5859 5.88455 18.457L4.93533 21.8438L0.400176 25.8047C-0.0802925 26.2266-0.138886 27.0117 0.282989 27.4922Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguremartialarts);
export default __webpack_public_path__ + "static/media/figure.martial.arts.bf659d6f78711cdd03527b8e1003cf8e.svg";
export { ForwardRef as ReactComponent };